__turbopack_context__.v({
  "button-wrapper": "savings-calculator-module-scss-module__UkhrOa__button-wrapper",
  "chart-wrapper": "savings-calculator-module-scss-module__UkhrOa__chart-wrapper",
  "form": "savings-calculator-module-scss-module__UkhrOa__form",
  "input-group": "savings-calculator-module-scss-module__UkhrOa__input-group",
  "results": "savings-calculator-module-scss-module__UkhrOa__results",
  "submit": "savings-calculator-module-scss-module__UkhrOa__submit",
  "success-wrapper": "savings-calculator-module-scss-module__UkhrOa__success-wrapper",
  "total-row": "savings-calculator-module-scss-module__UkhrOa__total-row",
  "totals": "savings-calculator-module-scss-module__UkhrOa__totals",
});
